import { render, staticRenderFns } from "./Recover.vue?vue&type=template&id=2b0bc6be&scoped=true&"
import script from "./Recover.vue?vue&type=script&lang=js&"
export * from "./Recover.vue?vue&type=script&lang=js&"
import style0 from "./Recover.vue?vue&type=style&index=0&id=2b0bc6be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0bc6be",
  null
  
)

export default component.exports